import { NumberInput } from 'govwell-ui'

import { NumberFormat } from 'src/utils/number'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  errorMessage?: React.ReactNode
  field: TanstackField<number | null | undefined, TKey>
  format?: NumberFormat
  isInvalid?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  max?: number
  min?: number
  placeholder?: string
  width?: React.CSSProperties['width']
}
const NumberField = <TKey extends string>({
  caption,
  field,
  format,
  isRequired,
  label,
  placeholder,
  width,
  errorMessage: propErrorMessage,
  isInvalid: propIsInvalid,
  max,
  min,
}: Props<TKey>) => {
  const errorMessage = propErrorMessage || field.state.meta.errors.join(', ')
  const isInvalid = propIsInvalid || !!errorMessage

  return (
    <NumberInput
      caption={caption}
      format={format}
      label={label}
      isRequired={isRequired}
      onValueChange={field.setValue}
      placeholder={placeholder}
      value={field.state.value}
      width={width}
      errorMessage={errorMessage}
      isInvalid={isInvalid}
      onBlur={field.handleBlur}
      max={max}
      min={min}
    />
  )
}

export default NumberField
